import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_GenericRenderer, ComponentSync, EditableDBItemV3, LL_V_L, ModuleFE_Utils, TS_Tabs } from '@nu-art/thunderstorm-frontend';
import './Editor_DiseaseProfile.scss';
import { Manager_DiseaseProfile_ProfileTab_Epidemiology, Manager_DiseaseProfile_ProfileTab_General, Manager_DiseaseProfile_ProfileTab_Prognosis, Manager_DiseaseProfile_ProfileTab_References, Manager_DiseaseProfile_ProfileTab_Scores } from '../../types.js';
import { RendererKey_DiseaseProfileReview } from '@app/dp-shared';
import { arrayIncludesAny, asArray, BadImplementationException, dbObjectToId } from '@nu-art/ts-common';
import { ModuleFE_DiseaseProfile } from '../../../../../_entity.js';
import { Editor_DiseaseProfile_General } from './tabs/Editor_DiseaseProfile_General/Editor_DiseaseProfile_General.js';
import { Editor_DiseaseProfile_Scores } from './tabs/Editor_DiseaseProfile_Scores/Editor_DiseaseProfile_Scores.js';
import { Editor_DiseaseProfile_References } from './tabs/Editor_DiseaseProfile_References/Editor_DiseaseProfile_References.js';
import { Editor_DiseaseProfile_Epidemiology } from './tabs/Editor_DiseaseProfile_Epidemiology/Editor_DiseaseProfile_Epidemiology.js';
import { Editor_DiseaseProfile_Prognosis } from './tabs/Editor_DiseaseProfile_Prognosis/Editor_DiseaseProfile_Prognosis.js';
export class Editor_DiseaseProfile extends ComponentSync {
    // ######################## Life Cycle ########################
    __onDiseaseProfileUpdated = (...params) => {
        const currentlyEditedDP = asArray(params[1]).find(dp => dp._id === this.state.editable.item._id);
        if (!currentlyEditedDP)
            return;
        if (currentlyEditedDP.__updated !== this.state.editable.item.__updated)
            this.setState({ editable: this.getEditable(currentlyEditedDP._id) });
    };
    __onReferencesUpdated = (...params) => {
        //Force re-render if one of the references under this disease profile has been updated and the references tab is currently open
        if (this.state.renderArgs.profile.selectedTab !== Manager_DiseaseProfile_ProfileTab_References)
            return;
        const updatedRefIds = asArray(params[1]).map(dbObjectToId);
        const currentRefIds = this.state.editable.item.referenceIds ?? [];
        if (arrayIncludesAny(currentRefIds, updatedRefIds))
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.tabId = nextProps.tabId;
        state.renderArgs = nextProps.renderArgs;
        if (state.tabId !== this.state?.tabId)
            state.editable = this.getEditable(state.renderArgs.itemId);
        return state;
    }
    // ######################## Logic ########################
    getEditable(diseaseProfileId) {
        const diseaseProfile = ModuleFE_DiseaseProfile.cache.unique(diseaseProfileId);
        if (!diseaseProfile)
            throw new BadImplementationException(`Could not find disease profile for id ${diseaseProfileId}`);
        return new EditableDBItemV3(diseaseProfile, ModuleFE_DiseaseProfile)
            .setAutoSave(true)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(i => {
            this.forceUpdate();
            this.props.workHubItem.updateTabLabel(this.state.tabId, i.label);
        })
            .setDebounceTimeout(200);
    }
    getTabs = () => {
        return [
            {
                uid: Manager_DiseaseProfile_ProfileTab_General,
                title: 'General',
                content: () => _jsx(Editor_DiseaseProfile_General, { editable: this.state.editable, editMode: this.state.renderArgs.editMode })
            },
            {
                uid: Manager_DiseaseProfile_ProfileTab_Scores,
                title: 'Scores',
                content: () => _jsx(Editor_DiseaseProfile_Scores, { editable: this.state.editable, editMode: this.state.renderArgs.editMode })
            },
            {
                uid: Manager_DiseaseProfile_ProfileTab_Epidemiology,
                title: 'Epidemiology',
                content: () => _jsx(Editor_DiseaseProfile_Epidemiology, { editable: this.state.editable, editMode: this.state.renderArgs.editMode })
            },
            {
                uid: Manager_DiseaseProfile_ProfileTab_Prognosis,
                title: 'Prognosis',
                content: () => _jsx(Editor_DiseaseProfile_Prognosis, { editable: this.state.editable, editMode: this.state.renderArgs.editMode })
            },
            {
                uid: Manager_DiseaseProfile_ProfileTab_References,
                title: 'References',
                content: () => _jsx(Editor_DiseaseProfile_References, { editable: this.state.editable, editMode: this.state.renderArgs.editMode })
            },
        ];
    };
    // ######################## Render ########################
    // Generic UI slot for the optional "Review" section (link that opens the imported HTML overlay).
    // Disease-profile owns the location; data-migration registers the component (so dp never imports it).
    // Guarded: getRenderer throws when nothing is registered.
    renderReviewSlot = () => {
        if (!ModuleFE_Utils.renderers[RendererKey_DiseaseProfileReview])
            return null;
        return _jsx(Component_GenericRenderer, { rendererKey: RendererKey_DiseaseProfileReview, props: { tabId: this.state.tabId, diseaseProfileId: this.state.renderArgs.itemId, editMode: this.state.renderArgs.editMode } }, this.state.renderArgs.itemId);
    };
    render() {
        return _jsxs(LL_V_L, { className: 'e__disease-profile', children: [_jsx("h1", { children: "Description" }), this.renderReviewSlot(), _jsx(TS_Tabs, { tabs: this.getTabs(), selectedTabId: this.state.renderArgs.profile.selectedTab, onSelected: tabId => {
                        const args = { ...this.state.renderArgs.profile, selectedTab: tabId };
                        this.props.workHubItem.updateArgs(this.state.tabId, { profile: args });
                    } })] });
    }
}
//# sourceMappingURL=Editor_DiseaseProfile.js.map